document.addEventListener('DOMContentLoaded', function () {
  if (!window.isLogin) {
    localStorage.removeItem(window.customerAccessTokenKey);
    // Clear favourites cache when logged out
    try {
      localStorage.removeItem('favourites_ids');
    } catch (_) {}
  }

  // Function to toggle d-none on sidebar-filter-section based on screen width
  function toggleSidebarFilterVisibility() {
      const sidebarFilterSections = document.querySelectorAll('.sidebar .sidebar-filter-section');
      const sidebarSections = document.querySelectorAll('.sidebar .sidebar-section');
      const homeOtherSidebar = document.querySelector('.home-page .home-other .sidebar');
      const homeOrderFlow = document.querySelector('.home-page .order-flow');

      if (window.innerWidth <= 768) {
          sidebarFilterSections.forEach(section => {
              section.classList.add('d-none');
          });
          sidebarSections.forEach(section => {
              section.classList.add('d-none');
          });

          if (homeOtherSidebar) {
            homeOtherSidebar.classList.add('d-none');
          }

          if (homeOrderFlow) {
            homeOrderFlow.classList.add('d-none');
          }
      } else {
          sidebarFilterSections.forEach(section => {
              section.classList.remove('d-none');
          });
          sidebarSections.forEach(section => {
              section.classList.remove('d-none');
          });
          
          if (homeOtherSidebar) {
            homeOtherSidebar.classList.remove('d-none');
          }

          if (homeOrderFlow) {
            homeOrderFlow.classList.remove('d-none');
          }
      }
  }

  // Mobile header fixed on scroll functionality
  let mobileHeaderState = {
    mobileHeaderTop: null,
    headerMain: null,
    isFixed: false,
    headerTopOffset: 0
  };

  function initMobileHeaderFixed() {
    mobileHeaderState.mobileHeaderTop = document.querySelector('.mobile-header-top');
    mobileHeaderState.headerMain = document.querySelector('.header-main');
    
    if (mobileHeaderState.mobileHeaderTop && window.innerWidth <= 768) {
      mobileHeaderState.headerTopOffset = mobileHeaderState.mobileHeaderTop.offsetTop;
    }
  }

  function handleMobileHeaderScroll() {
    if (!mobileHeaderState.mobileHeaderTop || window.innerWidth > 768) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > mobileHeaderState.headerTopOffset && !mobileHeaderState.isFixed) {
      mobileHeaderState.mobileHeaderTop.classList.add('fixed');
      if (mobileHeaderState.headerMain) {
        mobileHeaderState.headerMain.classList.add('has-fixed-header');
      }
      mobileHeaderState.isFixed = true;
    } else if (scrollTop <= mobileHeaderState.headerTopOffset && mobileHeaderState.isFixed) {
      mobileHeaderState.mobileHeaderTop.classList.remove('fixed');
      if (mobileHeaderState.headerMain) {
        mobileHeaderState.headerMain.classList.remove('has-fixed-header');
      }
      mobileHeaderState.isFixed = false;
    }
  }

  function handleMobileHeaderResize() {
    if (!mobileHeaderState.mobileHeaderTop) return;

    if (window.innerWidth > 768) {
      // Remove fixed classes on desktop
      mobileHeaderState.mobileHeaderTop.classList.remove('fixed');
      if (mobileHeaderState.headerMain) {
        mobileHeaderState.headerMain.classList.remove('has-fixed-header');
      }
      mobileHeaderState.isFixed = false;
    } else {
      // Recalculate offset on mobile
      mobileHeaderState.headerTopOffset = mobileHeaderState.mobileHeaderTop.offsetTop;
    }
  }

  // PC header fixed on scroll functionality
  let pcHeaderState = {
    headerMod: null,
    isFixed: false,
    headerHeight: 0
  };

  function initPcHeaderFixed() {
    pcHeaderState.headerMod = document.querySelector('.header_mod');
    if (pcHeaderState.headerMod && window.innerWidth >= 768) {
      pcHeaderState.headerHeight = pcHeaderState.headerMod.offsetHeight;
    }
  }

  function handlePcHeaderScroll() {
    if (!pcHeaderState.headerMod || window.innerWidth < 768) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

    if (scrollTop > 0 && !pcHeaderState.isFixed) {
      pcHeaderState.headerHeight = pcHeaderState.headerMod.offsetHeight;
      pcHeaderState.headerMod.classList.add('pc-fixed');
      document.body.style.paddingTop = pcHeaderState.headerHeight + 'px';
      pcHeaderState.isFixed = true;
    } else if (scrollTop <= 0 && pcHeaderState.isFixed) {
      pcHeaderState.headerMod.classList.remove('pc-fixed');
      document.body.style.paddingTop = '';
      pcHeaderState.isFixed = false;
    }
  }

  function handlePcHeaderResize() {
    if (!pcHeaderState.headerMod) return;

    if (window.innerWidth < 768) {
      pcHeaderState.headerMod.classList.remove('pc-fixed');
      document.body.style.paddingTop = '';
      pcHeaderState.isFixed = false;
    } else if (pcHeaderState.isFixed) {
      pcHeaderState.headerHeight = pcHeaderState.headerMod.offsetHeight;
      document.body.style.paddingTop = pcHeaderState.headerHeight + 'px';
    }
  }

  // Global event handlers
  function handleScroll() {
    handleMobileHeaderScroll();
    handlePcHeaderScroll();
  }

  function updateHeaderHeight() {
    const header = document.querySelector('.header_mod');
    if (header && window.innerWidth <= 767) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    } else if (window.innerWidth > 767) {
      document.documentElement.style.removeProperty('--header-height');
    }
  }

  function handleResize() {
    toggleSidebarFilterVisibility();
    handleMobileHeaderResize();
    handlePcHeaderResize();
    updateHeaderHeight();
  }

  // Initialize functions
  toggleSidebarFilterVisibility();
  initMobileHeaderFixed();
  initPcHeaderFixed();
  updateHeaderHeight();

  // Global event listeners
  window.addEventListener('scroll', handleScroll);
  document.body.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleResize);
  window.addEventListener('load', updateHeaderHeight);

  // Check if current page is cart page
  function isCartPage() {
    return window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart/');
  }

  // Add close button to _my_embed_block elements
  function addCloseButtonToEmbedBlock(embedBlock) {
    // Only show on cart page
    if (!isCartPage()) {
      return;
    }

    // Add visible class to show the block
    embedBlock.classList.add('_my_embed_block_visible');

    // Check if close button already exists
    if (embedBlock.querySelector('._my_embed_block_close_btn')) {
      return;
    }

    // Create close button
    const closeBtn = document.createElement('button');
    closeBtn.className = '_my_embed_block_close_btn';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.innerHTML = '×';

    // Add click event to close the block
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      embedBlock.classList.add('_my_embed_block_closed');
    });

    // Insert close button at the beginning of the block
    embedBlock.insertBefore(closeBtn, embedBlock.firstChild);
  }

  // Function to initialize close buttons for all existing embed blocks
  function initializeEmbedBlockCloseButtons() {
    const embedBlocks = document.querySelectorAll('._my_embed_block:not(._my_embed_block_closed)');
    embedBlocks.forEach(block => {
      addCloseButtonToEmbedBlock(block);
    });
  }

  // Initialize on page load
  initializeEmbedBlockCloseButtons();

  // Watch for dynamically added embed blocks using MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is an embed block
          if (node.classList && node.classList.contains('_my_embed_block')) {
            addCloseButtonToEmbedBlock(node);
          }
          // Check if any embed blocks were added inside the node
          const embedBlocks = node.querySelectorAll && node.querySelectorAll('._my_embed_block:not(._my_embed_block_closed)');
          if (embedBlocks) {
            embedBlocks.forEach(block => {
              addCloseButtonToEmbedBlock(block);
            });
          }
        }
      });
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});